import ConfirmationDialog from '../../../../../components/dialog/ConfirmationDialog';
import '../SearchBarAction.scss';

const CancelDialog = ({
  title,
  open,
  onClose,
  onCancel,
} = {
  title: '',
  open: false,
  onClose: () => null,
  onCancel: () => null,
}) => {
  if (!open) {
    return null;
  }
  return (
    <ConfirmationDialog
      open={open}
      title={title}
      contentText={(
        <div>
          Are you sure?
          <br />
          Cancelling will delete any unsaved changes.
        </div>
      )}
      confirmLabel='Go Back'
      cancelLabel='Cancel'
      onConfirm={() => { onClose(); }}
      onCancel={() => { onClose(); onCancel(); }}
      confirmClass='wide-button'
      cancelClass='wide-button'
    />
  );
};

export default CancelDialog;
